import React from 'react';
import { Phone, Globe, Tag } from 'lucide-react';

export const FacebookIcon: React.FC<{ size?: number }> = ({ size = 10 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}>
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

export const TikTokIcon: React.FC<{ size?: number }> = ({ size = 10 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}>
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.24 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
);

export const GoogleIcon: React.FC<{ size?: number }> = ({ size = 10 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}>
    <path fill="#4285F4" d="M23.745 12.27c0-.7-.06-1.4-.19-2.07H12v4.51h6.6c-.29 1.52-1.14 2.82-2.4 3.68v3.05h3.88c2.27-2.09 3.665-5.17 3.665-9.17z" />
    <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.88-3.05c-1.08.72-2.45 1.16-4.05 1.16-3.12 0-5.77-2.1-6.72-4.93H1.25v3.15C3.26 21.36 7.33 24 12 24z" />
    <path fill="#FBBC05" d="M5.28 14.27c-.25-.72-.38-1.49-.38-2.27s.13-1.55.38-2.27V6.58H1.25C.45 8.18 0 9.98 0 12s.45 3.82 1.25 5.42l4.03-3.15z" />
    <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.33 0 3.26 2.64 1.25 6.58l4.03 3.15c.95-2.83 3.6-4.98 6.72-4.98z" />
  </svg>
);

export const WhatsAppIcon: React.FC<{ size?: number }> = ({ size = 10 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}>
    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
  </svg>
);

interface TrafficSourceBadgeProps {
  order: any;
  className?: string;
  style?: React.CSSProperties;
}

export const TrafficSourceBadge: React.FC<TrafficSourceBadgeProps> = ({
  order,
  className = '',
  style,
}) => {
  if (!order) return null;

  const source = (order.traffic_source || (order.source === 'manual' ? 'manual' : 'organic')).toLowerCase();
  const campaign = order.utm_campaign;
  const tooltip = campaign
    ? `Platform: ${source.toUpperCase()} | Campaign: ${campaign}`
    : (order.traffic_source_display || source);

  if (source === 'facebook') {
    return (
      <div className={`om-source-badge-wrap ${className}`.trim()} style={style} title={tooltip}>
        <span className="om-badge om-badge-facebook">
          <FacebookIcon size={10} />
          <span>FB Ads</span>
        </span>
        {campaign && (
          <span className="om-campaign-pill" title={`Campaign: ${campaign}`}>
            <Tag size={8} style={{ flexShrink: 0 }} />
            <span className="om-campaign-name">{campaign}</span>
          </span>
        )}
      </div>
    );
  }

  if (source === 'tiktok') {
    return (
      <div className={`om-source-badge-wrap ${className}`.trim()} style={style} title={tooltip}>
        <span className="om-badge om-badge-tiktok">
          <TikTokIcon size={10} />
          <span>TikTok Ads</span>
        </span>
        {campaign && (
          <span className="om-campaign-pill" title={`Campaign: ${campaign}`}>
            <Tag size={8} style={{ flexShrink: 0 }} />
            <span className="om-campaign-name">{campaign}</span>
          </span>
        )}
      </div>
    );
  }

  if (source === 'google') {
    return (
      <div className={`om-source-badge-wrap ${className}`.trim()} style={style} title={tooltip}>
        <span className="om-badge om-badge-google">
          <GoogleIcon size={10} />
          <span>Google Ads</span>
        </span>
        {campaign && (
          <span className="om-campaign-pill" title={`Campaign: ${campaign}`}>
            <Tag size={8} style={{ flexShrink: 0 }} />
            <span className="om-campaign-name">{campaign}</span>
          </span>
        )}
      </div>
    );
  }

  if (source === 'whatsapp') {
    return (
      <div className={`om-source-badge-wrap ${className}`.trim()} style={style} title={tooltip}>
        <span className="om-badge om-badge-whatsapp">
          <WhatsAppIcon size={10} />
          <span>WhatsApp</span>
        </span>
        {campaign && (
          <span className="om-campaign-pill" title={`Campaign: ${campaign}`}>
            <Tag size={8} style={{ flexShrink: 0 }} />
            <span className="om-campaign-name">{campaign}</span>
          </span>
        )}
      </div>
    );
  }

  if (source === 'manual') {
    return (
      <div className={`om-source-badge-wrap ${className}`.trim()} style={style} title={tooltip || 'Manual Phone/Call Order'}>
        <span className="om-badge om-badge-manual">
          <Phone size={9} />
          <span>MANUAL</span>
        </span>
        {campaign && (
          <span className="om-campaign-pill" title={`Campaign: ${campaign}`}>
            <Tag size={8} style={{ flexShrink: 0 }} />
            <span className="om-campaign-name">{campaign}</span>
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={`om-source-badge-wrap ${className}`.trim()} style={style} title={tooltip || 'Direct / Organic website order'}>
      <span className="om-badge om-badge-landing">
        <Globe size={9} />
        <span>DIRECT</span>
      </span>
      {campaign && (
        <span className="om-campaign-pill" title={`Campaign: ${campaign}`}>
          <Tag size={8} style={{ flexShrink: 0 }} />
          <span className="om-campaign-name">{campaign}</span>
        </span>
      )}
    </div>
  );
};

export default TrafficSourceBadge;
